/**
 * Lifecycle events an admin's Open SSO session reports to
 * `POST /api/admin/users/:aba/:client_id/sso/events`, which writes each one to
 * the audit log as `admin.sso.<event>` and rejects anything outside this set.
 *
 * Mirrors `Constants.SSO_EVENTS` in clockout-service — the service is the
 * authority; these must not drift from it.
 *
 * There is no `warning_confirmed`. Confirming the warning IS the call to
 * `POST .../sso/session`, which writes `admin.sso.session_opened`; a separate
 * confirmed event would double-count every session.
 *
 * Lives here (not in `open-sso/openSso.constants.js`) because
 * `common/userActions` reports these too, and a shared component must not
 * import from a feature folder.
 */
export const SSO_EVENTS = {
    WARNING_SHOWN: 'warning_shown',
    WARNING_CANCELLED: 'warning_cancelled',
    SESSION_CLOSED: 'session_closed',
};

/**
 * Why the Open SSO control is disabled instead of missing, for the two surfaces
 * that render it (the user page header and the Reports detail panel). Kept here
 * for the same reason as SSO_EVENTS: two surfaces, one wording.
 *
 * Disabled rather than hidden on purpose — an admin who lacks the scope would
 * otherwise have no way to learn the action exists, and this one is worth
 * asking for: admin:sso:open is delegable, so their FI's owner can grant it
 * from the Role Composer. Naming the permission is what makes that ask
 * possible, which is why the tooltip does not say "owner-only" — it is not.
 */
export const SSO_DISABLED_TOOLTIP = 'Requires the Open SSO permission.';
